import { Config } from '@leverege/plugin';
const constants = () => ({
  manufactured: 'Manufactured',
  'in-transit': 'In Transit',
  available: 'Unpaired',
  paired: 'Paired',
  sold: 'Sold',
  'drive-off': 'Lost - Confirmed Drive Off',
  'assumed-drive-off': 'Lost - Assumed Drive Off',
  'suspected-drive-off': 'Suspected Drive Off',
  'suspected-off-lot': 'Suspected Off Lot',
  'not-reporting': 'Not Reporting',
  'non-operational': 'Not Operational',
  'subscription-expired': 'Subscription Expired',
  stolen: 'Lost - Stolen',
  'marked-as-lost': 'Lost - Marked as Lost',
  'sale-pending-remove': Config.get('PendingSaleMessage', 'label', 'Sale Pending, Unpair Locator'),
  'sale-pending-replace': 'Sale Pending, Replace Locator',
  'sale-pending': 'Sale Pending, Unpair Locator',
  'sold-low-battery': 'Sold with Low Battery',
  'sold-offline': 'Sold with Offline Locator',
  pendingAddLocator: 'Sale Pending, Add Locator',
  'not-applicable': 'N/A',
  'support-required': 'Lost - Support Required',
  'reconciliation-pending': 'Position Pending',
  'off-lot': 'Lost - Off Lot',
  converting: 'Converting',
  converted: 'Converted to Gateway',
  lost: 'Lost'
});
export default constants;